export const tabs = {
    timetable: 'timetable',
    timetablePlanning: 'timetablePlanning',
    timetableAnalytics: 'timetableAnalytics',
}